// src/pages/WishlistPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import ProductCard from '../components/Products/ProductCard';

const WishlistPage = () => {
  const { wishlistItems } = useWishlist();

  if (wishlistItems.length === 0) {
    return (
      <div className="py-8 max-w-6xl mx-auto px-4">
        <div className="text-center py-20 bg-white rounded-2xl border border-gray-100 shadow-sm">
          <i className="fas fa-heart text-6xl text-gray-200 mb-5"></i>
          <h2 className="text-2xl font-black text-gray-900 mb-2">Your wishlist is empty</h2>
          <p className="text-gray-500 mb-6 font-medium">Start adding items you love to your wishlist!</p>
          <Link to="/quick" className="inline-block px-8 py-3 bg-[#FF7A59] text-white rounded-xl font-bold transition-colors hover:bg-orange-600 shadow-md">
            Start Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="py-6 max-w-[1200px] mx-auto px-4 min-h-[60vh]">
      {/* Header */}
      <div className="flex items-center justify-between mb-8 border-b border-gray-100 pb-4">
        <h1 className="text-2xl md:text-3xl font-black text-[#0F2F63] flex items-center gap-3">
          <i className="fas fa-heart text-[#FF7A59]"></i>
          My Wishlist
          <span className="text-base text-gray-500 font-bold bg-gray-100 px-3 py-1 rounded-full">
            {wishlistItems.length} {wishlistItems.length === 1 ? 'item' : 'items'}
          </span>
        </h1>
      </div>

      {/* Grid using ProductCard component */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
        {wishlistItems.map(item => (
           <ProductCard 
              key={item.outletVariantId || item.id || item.productId} 
              product={item} 
           />
        ))}
      </div>
    </div>
  );
};

export default WishlistPage;